import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { PerformancePeriod } from './performance-period.model';

export class PerformancePeriodStateModel extends EntityStateModel<PerformancePeriod> {}
